import { render, staticRenderFns } from "./FileManagement.vue?vue&type=template&id=5dc5cba2&scoped=true&"
import script from "./FileManagement.vue?vue&type=script&lang=js&"
export * from "./FileManagement.vue?vue&type=script&lang=js&"
import style0 from "./FileManagement.vue?vue&type=style&index=0&id=5dc5cba2&scoped=true&lang=css&"
import style1 from "./FileManagement.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc5cba2",
  null
  
)

export default component.exports